import { Progress } from "../ui/progress";

const CATEGORIES = [
  { key: "contactability", label: "Contactability", max: 25 },
  { key: "seniority", label: "Seniority", max: 20 },
  { key: "company_fit", label: "Company Fit", max: 20 },
  { key: "engagement", label: "Engagement", max: 20 },
  { key: "recency", label: "Recency", max: 15 },
];

export default function ScoreBreakdown({ breakdown }) {
  if (!breakdown) return null;

  return (
    <div className="space-y-2">
      {CATEGORIES.map(({ key, label, max }) => {
        const value = breakdown[key] || 0;
        const pct = Math.round((value / max) * 100);
        return (
          <div key={key} className="flex items-center gap-2">
            <span className="text-xs text-muted-foreground w-24 shrink-0">{label}</span>
            <Progress value={pct} className="h-2 flex-1" />
            <span className="text-xs font-mono w-10 text-right">{value}/{max}</span>
          </div>
        );
      })}
      {breakdown.penalties < 0 && (
        <div className="flex items-center gap-2">
          <span className="text-xs text-red-500 w-24 shrink-0">Penalties</span>
          <span className="text-xs font-mono text-red-500">{breakdown.penalties}</span>
        </div>
      )}
    </div>
  );
}
